import styled from 'styled-components';
import {INK} from '../onboarding/review/reviewStyles';

/** The one primary action on a forward-flow surface, on the shared ABF tokens. */
export const PrimaryAction = styled.button`
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  min-height: 36px; padding: 8px 14px; border: 1px solid rgba(56, 189, 248, 0.6); border-radius: 9px;
  background: rgba(14, 116, 144, 0.55); color: ${INK.strong}; font: inherit; font-size: 13px; font-weight: 750;
  cursor: pointer; white-space: nowrap;
  &:hover:not(:disabled) { border-color: ${INK.accent}; }
  &:focus-visible { outline: 2px solid ${INK.accent}; outline-offset: 2px; }
  &:disabled { opacity: .5; cursor: not-allowed; }
`;

/** Views inside one workspace. */
export const WorkTabs = styled.div`
  display: flex; flex-wrap: wrap; gap: 5px; padding: 5px; margin-bottom: 16px; width: fit-content; max-width: 100%;
  border: 1px solid ${INK.line}; border-radius: 10px; background: ${INK.raised};
  button { min-height: 36px; padding: 7px 14px; border: 0; border-radius: 7px; background: transparent;
    color: ${INK.muted}; cursor: pointer; font: inherit; font-size: 13px; font-weight: 650; }
  button[aria-selected='true'] { color: ${INK.strong}; background: #19334a; box-shadow: inset 0 -2px ${INK.accent}; }
  button:hover:not([aria-selected='true']) { color: ${INK.body}; background: ${INK.well}; }
  button:focus-visible { outline: 2px solid ${INK.accent}; outline-offset: -2px; }
`;
